import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  input,
  OnInit,
  runInInjectionContext,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormQuestion } from '../../core/models/form-group-mapping.model';
import { QuestionType } from '../../core/models/question/question-type.model';
import { Question } from '../../core/models/question/question.model';
import { RendererFormsRepository } from '../../core/repositories/renderer-forms.repository';
import { RendererQuestionsRepository } from '../../core/repositories/renderer-questions.repository';

@UntilDestroy()
@Component({
  selector: 'lib-question-container',
  templateUrl: './question-container.component.html',
  styleUrls: ['./question-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuestionContainerComponent implements OnInit, AfterViewChecked {
  formGroup = input.required<FormGroup<ControlsOf<FormQuestion>>>();
  showAllFollowUps = input<boolean>();
  questionsInRow = input<number>();
  labelPrefix = input<string>();
  repeaterGroupId = input<string>();
  formBuilder = input<boolean>();

  question: Signal<Question>;
  begaranId: string;
  QuestionType = QuestionType;
  isChangeRequest: boolean;
  showChanges: Signal<boolean | undefined>;

  constructor(
    private rendererQuestionsRepository: RendererQuestionsRepository,
    private cdr: ChangeDetectorRef,
    private injector: Injector,
    private rendererFormsRepository: RendererFormsRepository,
  ) {
    this.showChanges = toSignal(this.rendererFormsRepository.showChanges$);
  }

  ngOnInit(): void {
    runInInjectionContext(this.injector, () => {
      this.question = toSignal(
        this.rendererQuestionsRepository.select(this.formGroup().value.id),
      );
    });
    this.isChangeRequest = this.rendererFormsRepository.getIsChangeRequest();
  }

  ngAfterViewChecked() {
    this.cdr.markForCheck();
  }
}
